var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"pa-0"},_vm._l((_vm.countryes_map),function(item){return _c('v-col',{key:item.country,staticClass:"pa-0 px-1 pt-2"},[_c('CountCountryesSettings',{staticStyle:{"height":"100%"},attrs:{"data":_vm.courses[`${item.country}`],"flag":item['flag'],"title":item['title']}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }